import { Line } from "@react-three/drei";
import { useUIStore } from "../stores/uiStore";
import { tokens } from "../styles/tokens";

/** Warehouse-frame [x,y] polyline → world points at floor height (the
 *  SpaghettiLayer convention: warehouse +y is world +z, no sign flip). */
export function routePoints(line: [number, number][]): [number, number, number][] {
  return line.map(([x, y]) => [x, 0.06, y]);
}

/**
 * ADR 290: the active relocation what-if's loaded-leg routes, drawn on the
 * floor in CTA blue. Data comes from the uiStore simulation slice (already
 * capped server-side at 200 polylines); nothing renders when no simulation
 * is active for this warehouse.
 */
export function SimulationRoutesLayer({ warehouseId }: { warehouseId: string }) {
  const simulation = useUIStore((s) => s.simulation);
  if (!simulation || simulation.warehouseId !== warehouseId) return null;
  return (
    <group>
      {simulation.result.routes.map((line, i) => (
        line.length >= 2 && (
          <Line key={i} points={routePoints(line)} color={tokens.blue[500]}
                lineWidth={2} transparent opacity={0.85} />
        )
      ))}
    </group>
  );
}
